import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css'; // Mevcut stilleri kullanıyoruz

function Treatments() {
    const [treatments, setTreatments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [currentTreatment, setCurrentTreatment] = useState({ id: null, name: '', price: '' });

    useEffect(() => {
        fetchTreatments();
    }, []);

    const fetchTreatments = () => {
        axios.get('./backend/get_treatments.php')
            .then(res => {
                setTreatments(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post('./backend/save_treatment.php', currentTreatment)
            .then(res => {
                toast.success(res.data.message);
                setShowModal(false);
                fetchTreatments();
            })
            .catch(err => toast.error('İşlem başarısız.'));
    };

    const handleDelete = (id) => {
        if(window.confirm('Bu tedaviyi silmek istediğinize emin misiniz?')) {
            axios.post('./backend/delete_treatment.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchTreatments();
                });
        }
    };

    const openModal = (treatment = { id: null, name: '', price: '' }) => {
        setCurrentTreatment(treatment);
        setShowModal(true);
    };

    const handleExport = () => {
        const BOM = "\uFEFF";
        const headers = ["ID", "Tedavi Adı", "Fiyat"];
        const csvContent = headers.join(";") + "\n" + treatments.map(t => {
            return [
                t.id,
                `"${t.name}"`,
                parseFloat(t.price).toLocaleString('tr-TR', { minimumFractionDigits: 2 })
            ].join(";");
        }).join("\n");

        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "tedavi_listesi.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (loading) return <div>Yükleniyor...</div>;

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Tedavi ve Fiyat Listesi</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button className="add-btn" onClick={handleExport} style={{ background: 'linear-gradient(135deg, #f6c23e 0%, #dda20a 100%)', boxShadow: '0 4px 15px rgba(246, 194, 62, 0.4)' }}>Excel'e Aktar</button>
                    <button className="add-btn" onClick={() => openModal()}>+ Yeni Tedavi Ekle</button>
                </div>
            </div>

            <table className="data-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Tedavi Adı</th>
                        <th>Fiyat (TL)</th>
                        <th style={{textAlign: 'right'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {treatments.map(t => (
                        <tr key={t.id}>
                            <td data-label="ID">{t.id}</td>
                            <td data-label="Tedavi Adı">{t.name}</td>
                            <td data-label="Fiyat (TL)">{parseFloat(t.price).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                            <td data-label="İşlemler">
                                <div className="action-buttons" style={{justifyContent: 'flex-end'}}>
                                    <button className="edit-btn" onClick={() => openModal(t)}>Düzenle</button>
                                    <button className="delete-btn" onClick={() => handleDelete(t.id)}>Sil</button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {treatments.length === 0 && <tr><td colSpan="4" style={{textAlign:'center'}}>Kayıtlı tedavi bulunamadı.</td></tr>}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{currentTreatment.id ? 'Tedavi Düzenle' : 'Yeni Tedavi'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="treatmentForm" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Tedavi Adı</label>
                                    <input 
                                        type="text" 
                                        value={currentTreatment.name} 
                                        onChange={e => setCurrentTreatment({...currentTreatment, name: e.target.value})} 
                                        required 
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Fiyat (TL)</label>
                                    <input 
                                        type="number" 
                                        step="0.01" 
                                        value={currentTreatment.price} 
                                        onChange={e => setCurrentTreatment({...currentTreatment, price: e.target.value})} 
                                        required 
                                    />
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="treatmentForm" className="save-btn">Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Treatments;